import { gql } from "@apollo/client";
import { useMutation } from "@apollo/client/react";
import { ID } from "../../../utils/id";

interface Data {
  success: {
    message: string;
  };
}

interface Variables {
  id: ID;
}
const MUTATION = gql`
  mutation deleteCompanySetting($id: ID!) {
    success: deleteCompanySetting(id: $id) {
      message
    }
  }
`;

export const useDeleteCompanySettingMutation = (
  options: useMutation.Options<Data, Variables> = {},
): useMutation.ResultTuple<Data, Variables> => {
  const oldUpdate = options.update;
  options.update = (cache, result, options) => {
    cache.evict({
      fieldName: "getSettings",
    });
    cache.evict({
      id: `CompanySetting:${options.variables.id}`,
    });
    cache.evict({
      fieldName: "searchCompanySettings",
    });
    cache.gc();

    if (oldUpdate) {
      oldUpdate(cache, result, options);
    }
  };

  return useMutation<Data, Variables>(MUTATION, options);
};
